export default class BaseManager {
  constructor() {

  }
}
